module.exports = __webpack_public_path__ + "img/travel.ba179601.png";